import { useCallback } from 'react';

import { VisitDocumentTemplateType } from '@dreryk/egabinet-visit-frontend-api';

import { Button, ButtonVariant, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { PrintTemplateClickRegisterAction } from '~libs.desktop.shared.document-template';

import { documentTemplateActionTranslationKeys, visitTranslationKeys } from '../../../../../../translations';
import { selectDocumentTemplatePath } from '../../../DocumentTemplateAction.utils';

type DocumentTemplateFinishButtonProps = {
   readonly name: string;
   readonly type: VisitDocumentTemplateType;
   readonly visitId: number;
   readonly printTemplateId: number | undefined;
   readonly onDocumentTemplateOpen: VoidFunction;
};

export const DocumentTemplateFinishButton = (props: DocumentTemplateFinishButtonProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(false);

   const goToDocumentTemplate = useCallback<VoidFunction>(() => {
      push(selectDocumentTemplatePath(props.type, props.visitId, props.printTemplateId), {
         label: visitTranslationKeys.goBackToVisit,
      });
      props.onDocumentTemplateOpen();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.printTemplateId, props.visitId, push, props.onDocumentTemplateOpen, props.type]);

   return (
      <PrintTemplateClickRegisterAction>
         {({ registerClick }) => (
            <Button
               testId={`finish-${props.type}-${props.name}`}
               label={documentTemplateActionTranslationKeys.form.table.options.finish.label}
               onClick={() => {
                  if (props.printTemplateId !== undefined) {
                     registerClick({ printTemplateId: props.printTemplateId, printTemplateName: props.name });
                  }
                  goToDocumentTemplate();
               }}
               variant={ButtonVariant.PRIMARY}
               compact
            />
         )}
      </PrintTemplateClickRegisterAction>
   );
};
